import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../../../components/ui/alert-dialog';

export const DeleteTeamDialog = ({ open, onOpenChange, teamToDelete, teamHasPlayers, teamPlayerCount, deletingTeam, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Delete Team</AlertDialogTitle>
        <AlertDialogDescription>
          {teamHasPlayers ? (
            <>Warning: "{teamToDelete?.name}" has {teamPlayerCount} player(s) assigned.<br /><br />If you proceed, these players will be released back to the open pool.</>
          ) : (
            <>Are you sure you want to delete "{teamToDelete?.name}"? This action cannot be undone.</>
          )}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={deletingTeam}>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} disabled={deletingTeam} className="bg-red-600 hover:bg-red-700" data-testid="confirm-delete-team-btn">
          {deletingTeam ? 'Deleting...' : 'Delete'}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
